import SettingsService from 'src/services/settings'

export default {
  getSetting (type) {
    const promise = SettingsService.getSetting(type)

    promise.then(res => {
      const payload = res.data?.settings
      if (type === 'working_hours') {
        const workingHours = payload || { active: false, days: [] }
        this.workingHours = workingHours
      }
      else this.settings[type] = payload || {}
    })

    return promise
  },
  saveWorkingHours ({ type, settings }) {
    const current = this.workingHours

    this.workingHours = settings
    const promise = SettingsService.saveSetting({ type, settings })

    promise.then(res => {
      if (!res.data?.settings) {
        this.workingHours = current
      }
    })
    promise.catch(() => {
      this.workingHours = current
    })

    return promise
  },
  saveSetting ({ type, settings }) {
    const current = this.settings[type] || {}

    this.settings[type] = settings
    const promise = SettingsService.saveSetting({ type, settings })

    promise.then(res => {
      if (!res.data?.settings) {
        this.settings[type] = current
      }
    })
    promise.catch(() => {
      this.settings[type] = current
    })

    return promise
  }
}
